import { Role, ROLES } from './roles';

export type ConfigureNavIconConfig = {
  type: 'iconoir';
  name: 'CreateAgent' | 'Skill' | 'CubeBandage' | 'LightBulbOn' | 'DatabaseStar' | 'Tools' | 'Presentation' | 'Message' | 'Building';
};

export type ConfigureNavItem = {
  id: string;
  labelKey: string;
  path: string;
  icon: ConfigureNavIconConfig;
  /** If set, the item is shown only when the user has at least one of these roles. */
  roles?: Role[];
};

export const CONFIGURE_NAV_ITEMS: ConfigureNavItem[] = [
  {
    id: 'skills',
    labelKey: 'SKILLS',
    path: '/skills',
    icon: { type: 'iconoir', name: 'Skill' },
  },
  {
    id: 'knowledge-base',
    labelKey: 'KNOWLEDGE_BASE',
    path: '/knowledge-base',
    icon: { type: 'iconoir', name: 'DatabaseStar' },
  },
  {
    id: 'tools',
    labelKey: 'TOOLS',
    path: '/tools',
    icon: { type: 'iconoir', name: 'Tools' },
  },
  {
    id: 'usage-config',
    labelKey: 'USAGE_CONFIG',
    path: '/usage-config',
    icon: { type: 'iconoir', name: 'Presentation' },
    roles: [ROLES.SUPER_ADMIN],
  },
];

export const getVisibleConfigureNavItems = (userRoles: string[] = []) =>
  CONFIGURE_NAV_ITEMS.filter(
    (item) => !item.roles?.length || item.roles.some((role) => userRoles.includes(role))
  );

const CONFIGURE_ROUTE_PREFIXES = [
  '/configure',
  '/skills',
  '/knowledge-base',
  '/prompts',
  '/tools',
  '/tool-details',
  '/usage-config',
];

export const isConfigureRoute = (pathname: string) =>
  CONFIGURE_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );

/** Open the overlay sheet only when first entering Advanced, not when switching Advanced routes. */
export const shouldOpenConfigureOverlayOnPathChange = (
  previousPathname: string,
  nextPathname: string
) => isConfigureRoute(nextPathname) && !isConfigureRoute(previousPathname);

export const SIDEBAR_CONFIGURE_PANEL_WIDTH = '17.5rem';
